// Pricing helpers mirroring the mobile CartContext + backend repricing logic.

export function resolveTierPrice(qty, tiers) {
  if (!tiers || tiers.length === 0) return null;
  const q = Math.max(1, qty || 1);
  for (const t of tiers) {
    const lo = Math.max(1, t.min_qty || 1);
    const hi = t.max_qty ?? null;
    if (q >= lo && (hi === null || q <= hi)) return t.unit_price;
  }
  return tiers[tiers.length - 1]?.unit_price ?? null;
}

// Resolve the correct unit price for a product given a selected size + qty.
export function resolveUnitPrice(product, size, qty) {
  if (!product) return 0;
  const mode = product.pricing_mode || "single";
  if (mode === "sizes" && product.price_sizes?.length) {
    const match = product.price_sizes.find((s) => s.name === size);
    if (match) return match.quote ? 0 : match.price;
    return product.price;
  }
  if (mode === "tiers" && product.price_tiers?.length) {
    const t = resolveTierPrice(qty, product.price_tiers);
    return t ?? product.price;
  }
  return product.price;
}

// Is the given size an "Etc." quote size (price on request)?
export function isQuoteSize(product, size) {
  if (!product || (product.pricing_mode || "single") !== "sizes") return false;
  const match = (product.price_sizes || []).find((s) => s.name === size);
  return !!(match && match.quote);
}

// Sum of per-side surcharges on a cart line.
export function sidesSurcharge(item) {
  return (item.selected_sides || []).reduce((s, x) => s + (Number(x.price) || 0), 0);
}

// Cart line item unit price (recomputes for tiers, adds side surcharges).
export function priceForItem(item) {
  let base;
  if (item.pricing_mode === "tiers" && item.price_tiers?.length) {
    const t = resolveTierPrice(item.quantity, item.price_tiers);
    base = t ?? item.unit_price;
  } else {
    base = item.unit_price;
  }
  return base + sidesSurcharge(item);
}

// "From $X" style label for product cards.
export function priceLabel(product) {
  const mode = product.pricing_mode || "single";
  if (mode === "sizes" && product.price_sizes?.length) {
    const priced = product.price_sizes.filter((s) => !s.quote);
    if (priced.length === 0) return { quote: true };
    const min = Math.min(...priced.map((s) => s.price));
    return { prefix: "from", value: min };
  }
  if (mode === "tiers" && product.price_tiers?.length) {
    const min = Math.min(...product.price_tiers.map((t) => t.unit_price));
    return { prefix: "from", value: min, suffix: "/ea" };
  }
  return { prefix: "", value: product.price };
}

export function money(n) {
  return `$${Number(n || 0).toFixed(2)}`;
}

export const DELIVERY_OPTIONS = [
  { key: "pickup", label: "Pickup", desc: "Collect from us", fee: 0 },
  { key: "delivery_near", label: "Delivery (under 10 mi)", desc: "Within 10 miles", fee: 5 },
  { key: "delivery_far", label: "Delivery (10+ mi)", desc: "Beyond 10 miles", fee: 20 },
];
